export const API_URL = process.env.REACT_APP_API_URL || "";
export const YARN_FOCUS_API_URL =
  process.env.REACT_APP_YARN_FOCUS_API_URL || "";
export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL || "";
export const WAREHOUSE_API_URL = process.env.REACT_APP_WAREHOUSE || "";
export const ELASTIC_SEARCH_URL = process.env.REACT_APP_ELASTIC_SEARCH || "";
export const PDMS_API_URL = process.env.REACT_APP_PDMS_APP || "";
//export const REACT_APP_PRINTER_URL = process.env.REACT_APP_PRINTER_URL || "";
//export const COSTING_APP_URL = process.env.COSTING_URL || "";
//export const SAMPLE_APP_URL = process.env.SAMPLE_URL || "";
// export const OLD_WA_URL = process.env.REACT_APP_OLDWA_URL || "";
